.efb-click-action {
  display: inherit; // avoid misalignement in some occasions

  button,
  a {
    cursor: pointer;

    &:disabled {
      opacity: 0.7;

      pointer-events: none;
    }
  }

  button {
    display: block;

    font: inherit;

    background: none;
    border: initial;
  }

  a {
    color: currentColor;
    text-decoration: none;
  }
}
